var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/close-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00016 1.33325C4.32683 1.33325 1.3335 4.32659 1.3335 7.99992C1.3335 11.6733 4.32683 14.6666 8.00016 14.6666C11.6735 14.6666 14.6668 11.6733 14.6668 7.99992C14.6668 4.32659 11.6735 1.33325 8.00016 1.33325ZM10.2402 9.53325C10.4335 9.72659 10.4335 10.0466 10.2402 10.2399C10.1402 10.3399 10.0135 10.3866 9.88683 10.3866C9.76016 10.3866 9.6335 10.3399 9.5335 10.2399L8.00016 8.70659L6.46683 10.2399C6.36683 10.3399 6.24016 10.3866 6.1135 10.3866C5.98683 10.3866 5.86016 10.3399 5.76016 10.2399C5.56683 10.0466 5.56683 9.72659 5.76016 9.53325L7.2935 7.99992L5.76016 6.46659C5.56683 6.27325 5.56683 5.95325 5.76016 5.75992C5.9535 5.56659 6.2735 5.56659 6.46683 5.75992L8.00016 7.29325L9.5335 5.75992C9.72683 5.56659 10.0468 5.56659 10.2402 5.75992C10.4335 5.95325 10.4335 6.27325 10.2402 6.46659L8.70683 7.99992L10.2402 9.53325Z",
    fill: "#1b1d52"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChip);
export default __webpack_public_path__ + "static/media/close-chip.da788a58e92dc3f061416dedfdaea541.svg";
export { ForwardRef as ReactComponent };